import React, { PropTypes } from 'react';

import classNames from 'classnames/bind';
const cx = classNames.bind();

import { NitroIcon } from 'nitro-components';

import FormattedMetric from './FormattedMetric';

import Breakpoint from '../../../utils/breakpoints';

import styled from 'styled-components';

import { media, boolStyle, getStyle } from 'style-utils';

const styles = {
  start: {
    up: 'flex-end',
    down: 'flex-start'
  },
  end: {
    up: 'flex-start',
    down: 'flex-end'
  }
};

const MobileInsightsTrend = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  position: relative;

  color: ${props => props.theme.color.base1};
  font-size: 25px;
  margin-bottom: 10px;
`;

const TrendDescription = styled.p`
  font-size: 48px;
  color: ${props => props.theme.color.base1};
  text-align: center;
  margin: 20px 0;
  font-weight: normal;

  ${media.screen`
    margin: 20px 0 40px;
  `}

  ${media.mobileTablet`
    margin: 10px 0;
  `}

`;

// hide trend line is trends is empty
const Trend = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  position: relative;
  margin: 16px auto;
  width: 160px;
  height: 22px;

  color: ${props => props.theme.color[props.variant]};
  .icon {
    fill: ${props => props.theme.color[props.variant]};
  }

  ${boolStyle('hide', 'visibility: hidden;')}
`;

const TrendDelta = styled.span`
  color: ${props => props.theme.color.base2};
`;

const TrendNumber = styled.div`
  position: relative;
  font-size: 11px;
  line-height: 1;
  white-space: nowrap;
`;

const TrendIconWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  align-self: flex-start;
  text-align: center;
  height: 18px;
  padding: 0 5px;
`;

const TrendNumberStart = TrendNumber.extend`
  align-self: ${getStyle(styles.start, 'trend')};
`;

const TrendNumberEnd = TrendNumber.extend`
  align-self: ${getStyle(styles.end, 'trend')};
`;

export default class InsightTrend extends React.Component {
  render() {
    const {
      delta,
      trends,
      description,
      dataType,
      trendType,
      metric
    } = this.props;

    let showTrends = false;
    let start = { Value: 0 }, end = { Value: 0 };
    if (trends.length > 0) {
      showTrends = true;
      start = trends[0];
      end = trends[1];
    }

    const metricTrend = cx([
      {
        up: delta > 0,
        down: delta < 0,
        neutral: delta === 0
      }
    ]);

    const deltaNumber = delta === 0
      ? null
      : <TrendDelta>
          {'('}
          <FormattedMetric value={delta} dataType={dataType} />
          {')'}
        </TrendDelta>;

    return (
      <section>
        <Breakpoint name="tabletDesktop">
          <TrendDescription title={description}>
            <FormattedMetric value={metric} dataType={dataType} />
          </TrendDescription>

          <Trend hide={!showTrends} variant={trendType}>

            <TrendNumberStart trend={metricTrend} title={start.Description}>
              <FormattedMetric value={start.Value} dataType={dataType} />
            </TrendNumberStart>

            <TrendIconWrapper>
              <NitroIcon name={`trend-${metricTrend}`} size={28} />
              {/* <TrendIcon className={'icon-trend-' + metricTrend} /> */}
            </TrendIconWrapper>

            <TrendNumberEnd trend={metricTrend} title={end.Description}>
              <FormattedMetric value={end.Value} dataType={dataType} />
              {' '}
              {deltaNumber}
            </TrendNumberEnd>
          </Trend>
        </Breakpoint>

        <Breakpoint name="mobile">
          <MobileInsightsTrend>
            <FormattedMetric value={metric} dataType={dataType} />
            <NitroIcon
              name={`trend-mobile-${metricTrend}`}
              size={18}
              left={8}
              alignment
            />

          </MobileInsightsTrend>
        </Breakpoint>
      </section>
    );
  }
}

InsightTrend.propTypes = {
  metric: PropTypes.number,
  trends: PropTypes.array,
  delta: PropTypes.number,
  trendType: PropTypes.string,
  dataType: PropTypes.string,
  description: PropTypes.string
};



// WEBPACK FOOTER //
// ./src/features/insights/components/InsightTrend.js